export default __webpack_public_path__ + "static/media/Slide30.7efac154.jpg";